import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { faCaretSquareDown, faCaretSquareUp, faEye, faEyeSlash, faLayerGroup } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import EditLayersModal from "@/components/modal/components/edit-layers";
import { useModal } from "@/hooks/use-modal";
import * as editorActions from "@/lib/state/actions/editor-actions";
import { animationSelector } from "@/lib/state/selectors/animation-selector";
import { editorSelector } from "@/lib/state/selectors/editor-selector";

import EditorButton from "../editor-button";

const LayerSwitcher = () => {
  const { openModal } = useModal();
  const editorState = useSelector(editorSelector);
  const animationState = useSelector(animationSelector);
  const dispatch = useDispatch();

  const layerIsVisible =
    editorState.layerVisibility[editorState.currentLayerIndex];

  return (
    <div className="inline-block mx-4">
      <EditorButton
        onButtonPressed={() => openModal(() => <EditLayersModal />)}
        transient={true}
        label={<FontAwesomeIcon icon={faLayerGroup} />}
      />
      <EditorButton
        onButtonPressed={() => dispatch(editorActions.nextLayer())}
        transient={true}
        label={<FontAwesomeIcon icon={faCaretSquareUp} />}
        disabled={
          editorState.currentLayerIndex === animationState.layers.length - 1
        }
      />
      <EditorButton
        onButtonPressed={() => dispatch(editorActions.previousLayer())}
        transient={true}
        label={<FontAwesomeIcon icon={faCaretSquareDown} />}
        disabled={editorState.currentLayerIndex === 0}
      />
      <EditorButton
        onButtonPressed={() =>
          dispatch(
            editorActions.setLayerVisibility({
              layerIndex: editorState.currentLayerIndex,
              visible: !layerIsVisible,
            }),
          )
        }
        transient={true}
        label={
          layerIsVisible ? (
            <FontAwesomeIcon icon={faEye} />
          ) : (
            <FontAwesomeIcon icon={faEyeSlash} />
          )
        }
      />
      <span className="p-1 rounded-md bg-gray-100 shadow-sm">
        {animationState.layers[editorState.currentLayerIndex]}
      </span>
    </div>
  );
};

export default LayerSwitcher;
